import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/airtable.vue
var o = {
	name: "DtIconAirtable",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--airtable"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Airtable",
		viewBox: "0 0 24 24",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [
		r("path", {
			d: "M10.927 4.211 3.473 7.295a.5.5 0 0 0 .007.926l7.484 2.967c.658.261 1.39.261 2.048 0l7.484-2.968a.5.5 0 0 0 .007-.925L13.05 4.211a2.777 2.777 0 0 0-2.123 0",
			fill: "#FFBF00"
		}, null, -1),
		r("path", {
			d: "M12.652 12.81v7.413a.5.5 0 0 0 .684.465l8.34-3.237a.5.5 0 0 0 .315-.465V9.572a.5.5 0 0 0-.684-.464l-8.34 3.237a.5.5 0 0 0-.315.464",
			fill: "#26B5F8"
		}, null, -1),
		r("path", {
			d: "M10.705 13.192 8.23 14.387l-.251.121-5.225 2.504c-.331.16-.754-.082-.754-.45V9.603c0-.133.068-.248.16-.335a.568.568 0 0 1 .126-.094.532.532 0 0 1 .455-.035l7.922 3.139c.403.16.435.724.042.914",
			fill: "#ED3049"
		}, null, -1),
		r("path", {
			d: "M10.705 13.192 8.23 14.387 2.16 9.269a.567.567 0 0 1 .126-.095.532.532 0 0 1 .455-.035l7.922 3.139c.403.16.435.724.042.914",
			fill: "currentColor",
			"fill-opacity": ".25"
		}, null, -1)
	])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=airtable.js.map